import React from 'react';
import PaymentPerParticipantFP from '../FullPagesComponents/Services/Confirmation/PaymentPerParticipantFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';

//= ========================================================================

const ConfirmParticipantsDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SimulatorsViewerArrangement>
    <PaymentPerParticipantFP
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      withSelected
      numberOfParticipants={3}
    />
    <PaymentPerParticipantFP
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      numberOfParticipants={2}
    />
  </SimulatorsViewerArrangement>
);

export default ConfirmParticipantsDF;
